import React from 'react';

import CommonCheckbox from '../../../../components/common-checkbox/CommonCheckbox';
import HighlightedText from '../../../../components/highlighted-text/HighlightedText';

import scss from './BenchmarksNodeList.module.scss';

function OptionItem({ option, selectedOptions, onSelect, search }) {
  const { subheader, id } = option;

  const isSelected = selectedOptions?.some(({ id: optionId }) => optionId === id);

  const handleSelect = () => {
    onSelect(option);
  };

  return (
    <li className={scss.optionItem} onClick={handleSelect} role='presentation'>
      <CommonCheckbox checked={isSelected} readonly />
      <HighlightedText value={subheader} searchTerm={search} className={scss.optionLabel} />
    </li>
  );
}

export default OptionItem;
